import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';
import {
  GET_TURNOVER_DATA_ERROR,
  GET_TURNOVER_DATA_REQUEST,
  GET_TURNOVER_DATA_SUCCESS,
} from 'modules/turnoverPage/actions';

const initialState = {
  turnoverData: { datasets: {} },
  error: '',
  status: STATUS_NOT_REQUESTED,
};

export const turnoverPage = (state = initialState, action) => {
  switch (action.type) {
    case GET_TURNOVER_DATA_REQUEST:
      return {
        ...state,
        status: STATUS_LOADING,
      };

    case GET_TURNOVER_DATA_SUCCESS:
      return {
        ...state,
        turnoverData: action.payload.data,
        status: STATUS_SUCCESS,
      };

    case GET_TURNOVER_DATA_ERROR:
      return {
        ...state,
        status: STATUS_ERROR,
        error: action.payload.error,
        turnoverData: { datasets: {} },
      };

    default:
      return state;
  }
};
